module.exports = __webpack_public_path__ + "img/logo.ee6f3757.svg";